import { useState } from 'react';

interface ConfirmReadModalContentProps {
    onClose: () => void,
    onConfirm?: () => Promise<void> | void
}

const ConfirmReadModalContent = ({ onClose, onConfirm }: ConfirmReadModalContentProps) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleConfirm = async () => {
        setIsLoading(true);
        try {
            await onConfirm?.();

            onClose();
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className='bg-white rounded flex flex-col gap-6 md:gap-8 p-6 md:pt-8 md:pr-12 md:pb-8 md:pl-12 max-h-[85vh] md:max-h-none overflow-y-auto md:overflow-visible'>
            <p className='text-center text-lg font-medium mb-6'>
                このコンテンツの閲覧を開始しますか？
            </p>
            <div className='flex gap-4 w-full'>
                <button
                    onClick={onClose}
                    disabled={isLoading}
                    className='flex-1 py-4 px-6 border border-[#E7E7E7] rounded-[10px] font-semibold leading-[16px] disabled:opacity-50'
                >
                    いいえ
                </button>
                <button
                    onClick={handleConfirm}
                    disabled={isLoading}
                    className='flex-1 py-4 px-6 bg-primary text-white rounded-[10px] font-semibold leading-[16px] disabled:opacity-50'
                >
                    {isLoading ? '処理中...' : 'はい'}
                </button>
            </div>
        </div>
    );
};

export const showConfirmReadModal = (
    modalStore: any,
    onConfirm?: () => Promise<void> | void
) => {
    const modalId = 'confirm-read-all';

    modalStore.showModal({
        id: modalId,
        size: '700px',
        showCloseIcon: false,
        closeWhenOutside: true,
        showHeader: false,
        footer: null,
        contentClassName: 'shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] !p-0 rounded-[10px] bg-white outline-none',
        content: (
            <ConfirmReadModalContent
                onClose={() => modalStore.hideModal(modalId)}
                onConfirm={onConfirm}
            />
        )
    });
};

export default ConfirmReadModalContent;
